/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextLink from 'components/TextLink';
import { Form, FormActionTypes } from '@entrata/portals-common/lib/components/forms';
import { PasswordField } from '@entrata/portals-common/lib/standard-fields';
import { connect } from 'react-redux';
import { attemptChangePassword, setSuccessMessage } from 'redux/modules/user';
import styled from '@emotion/styled';
import { Dialog } from 'components/modals';
import { Btn } from 'components/buttons';
import { removeError } from 'redux/modules/errors';
import Message from 'components/Message';

const StyledFormField = styled(Form.Field)`
  margin-bottom: 8px;
  label {
    color: ${({ theme }) => theme.text.dark};
    font-size: 14px;
    font-weight: normal;
  }
  input {
    color: ${({ theme }) => theme.text.dark};
    border-radius: 5px;
  }
  span {
    position: static;
  }
`;

const images = {
  small: 'man_hands_using_laptop-550.jpg',
  large: 'man_hands_using_laptop.jpg',
};

const StyledWrapperDiv = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  margin-top: 43px;

  button[type='reset'] {
    margin-right: 18px;
  }

  @media only screen and (min-width: 526px) {
    justify-content: left;
    margin-top: 0;
  }
`;

export class ChangePassword extends Component {
  state = {
    loading: false,
  };
  handleSubmit = (values) => {
    this.setState({ loading: true });
    const { entityId, userId, employeeId, homebodyUserId } = this.props;
    this.props.attemptChangePassword({
      entityId,
      userId,
      employeeId,
      homebodyUserId,
      ...values,
    });
  };
  componentDidUpdate(prevProps) {
    const { changePasswordError, successMessage } = this.props;
    if (this.state.loading && !!changePasswordError) {
      this.setState({ loading: false });
    }
    if (this.state.loading && !!successMessage) {
      this.setState({ loading: false });
    }
  }
  handleClose = () => {
    const { onClose, removeError, setSuccessMessage } = this.props;
    removeError('changePassword');
    this.setState({ loading: false });
    setSuccessMessage({ message: '' });
    onClose();
  };
  initialFieldState = {
    currentPassword: { required: true },
    newPassword: { required: true },
  };
  fieldStateReducer = ({ state, changes: { name, type, payload } }) => {
    if (type === FormActionTypes.onChange) {
      const { removeError, changePasswordError, successMessage, setSuccessMessage } = this.props;
      !!successMessage && setSuccessMessage({ message: '' });
      !!changePasswordError && removeError('changePassword');
    }
    const isHandler = type === FormActionTypes.onChange || type === FormActionTypes.onBlur;
    if (name === 'currentPassword' && isHandler) {
      const { value } = payload['currentPassword'];
      return {
        ...state,
        ...payload,
        currentPassword: {
          ...payload['currentPassword'],
          error: !value ? 'REQUIRED' : value.length < 6 ? 'Minimum 6 char password required' : '',
        },
      };
    }
    if (name === 'newPassword' && isHandler) {
      const { value } = payload['newPassword'];
      return {
        ...state,
        ...payload,
        newPassword: {
          ...payload['newPassword'],
          error: !value
            ? 'REQUIRED'
            : value.length < 6
            ? 'Minimum 6 char password required'
            : value.length > 50
            ? 'Maximum 50 char password allowed'
            : '',
        },
      };
    }
    return payload;
  };
  render() {
    const { show, changePasswordError, successMessage } = this.props;
    const message = changePasswordError || successMessage;
    return (
      <Dialog sources={images} title='Change Password' onClose={this.handleClose} show={show}>
        <Message type={!!changePasswordError ? 'error' : 'success'} show={!!message}>
          {message}
        </Message>
        <Form initialFieldState={this.initialFieldState} fieldStateReducer={this.fieldStateReducer}>
          <StyledFormField name='currentPassword'>
            {(fieldProps) => <PasswordField {...fieldProps} label='Current Password' />}
          </StyledFormField>
          <StyledFormField name='newPassword'>
            {(fieldProps) => <PasswordField {...fieldProps} label='New Password' />}
          </StyledFormField>
          <Form.Actions>
            {({ hasErrors, values }) => (
              <StyledWrapperDiv>
                <TextLink type='reset' onClick={this.handleClose}>
                  Nevermind
                </TextLink>
                <Btn
                  appearance='primary'
                  type='submit'
                  disabled={hasErrors || !!successMessage}
                  loading={this.state.loading}
                  onClick={() => this.handleSubmit(values)}
                >
                  Save New Password
                </Btn>
              </StyledWrapperDiv>
            )}
          </Form.Actions>
        </Form>
      </Dialog>
    );
  }
}
ChangePassword.propTypes = {
  changePassword: PropTypes.string,
  entityId: PropTypes.number,
  userId: PropTypes.number,
  employeeId: PropTypes.number,
  successMessage: PropTypes.string,
  setSuccessMessage: PropTypes.func,
  attemptChangePassword: PropTypes.func,
  removeError: PropTypes.func,
  show: PropTypes.bool,
};
export const ChangedPassword = connect(
  ({ errors, user: { entityId, homebodyUserId, successMessage }, getQuote: { user, employee } }) => ({
    changePasswordError: errors.changePassword || '',
    entityId,
    homebodyUserId,
    userId: user,
    employeeId: employee.id,
    successMessage,
  }),
  { attemptChangePassword, removeError, setSuccessMessage }
)(ChangePassword);
export default ChangedPassword;
